import { FC, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

export type FullScreenLayoutProps = PropsWithChildren;

export const FullScreenLayout: FC<FullScreenLayoutProps> = ({ children }) => {
  return (
    <div className="flex min-h-screen min-w-[100vw] flex-col items-center justify-center bg-auth-background">
      {children ?? <Outlet />}
    </div>
  );
};
